import { Subject } from '~/rage/utils';
import { IInputService } from '../InputService';
import { ITuningTesterService, IVehicleMod } from './tuningTesterServiceTypes';

export class TuningTesterServiceStub implements ITuningTesterService {
	constructor(private readonly input: IInputService) {}

	private vehicleMods = new Subject<IVehicleMod[]>([
		{
			title: 'Спойлер',
			typeIndex: 0,
			modIndex: -1,
			maxCount: 10,
			modIdsByIndex: {
				0: 'dev_sultan_spoiler_0',
				1: 'dev_sultan_spoiler_1',
				2: 'dev_sultan_spoiler_2',
			},
		},
		{
			title: 'Передний бампер',
			typeIndex: 1,
			modIndex: -1,
			maxCount: 3,
			modIdsByIndex: {
				0: 'dev_sultan_front_bumper_0',
				1: 'dev_sultan_front_bumper_1',
			},
		},
		{
			title: 'Задний бампер',
			typeIndex: 2,
			modIndex: 0,
			maxCount: 5,
			modIdsByIndex: {
				0: 'dev_sultan_rear_bumper_0',
				1: 'dev_sultan_rear_bumper_1',
				2: 'dev_sultan_rear_bumper_2',
			},
		},
		{
			title: '(Задние мото) диски',
			typeIndex: 24,
			modIndex: 10,
			maxCount: 24,
			modIdsByIndex: {
				10: 'dev_bike_rear_wheel_10',
				11: 'dev_bike_rear_wheel_11',
				12: 'dev_bike_rear_wheel_12',
			},
		},
	]);

	public getVehicleMods(): Subject<IVehicleMod[]> {
		return this.vehicleMods;
	}

	public copyModId(modId: string): void {
		this.input.copyToClipboard(modId);
	}

	public async applyVehicleMod(
		modCategoryIndex: number,
		modIndex: number,
	): Promise<void> {
		console.log('tuningTester:applyVehicleMod', { modCategoryIndex, modIndex });
	}

	public async exitMenu(): Promise<void> {
		console.log('tuningTester:exitMenu');
	}
}
